export default "__VITE_ASSET__BhnED36Z__"